import MainLayout from '../Layouts/MainLayout';
import fondo_cont from "../assets/imagenes/fondo_contacto.jpg";
import { motion } from 'framer-motion';
import { useState } from 'react';
import '../App.css';

const Contactanos = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });

  const colors = {
    primary: '#1A6B77',
    secondary: '#FBAA2C',
    dark: '#1A1A1A',  
    light: '#FFFFFF',   
    gray: '#F4F4F4', 
    accent: '#E8F5F7'
};

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(prevStatus => ({ ...prevStatus, submitting: true }));

    const formDataToSend = new FormData();
    formDataToSend.append('access_key', process.env.REACT_APP_WEB3FORMS_KEY);
    formDataToSend.append('nombre', formData.nombre);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('asunto', formData.asunto);
    formDataToSend.append('mensaje', formData.mensaje);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend
      });
      
      const data = await response.json();
      
      if (data.success) {
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: '¡Mensaje enviado exitosamente!' }
        });
        setFormData({
          nombre: '',
          email: '',
          asunto: '',
          mensaje: ''
        });
      } else {
        setStatus({
          submitted: false,
          submitting: false,
          info: { error: true, msg: 'Ocurrió un error al enviar el mensaje.' }
        });
      }
    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Ocurrió un error al enviar el mensaje.' }
      });
    }
  };

  return (
    <MainLayout>
      <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="d-flex align-items-center position-relative"
      style={{
          backgroundImage: `url(${fondo_cont})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          color: '#fff'
      }}
      >
      <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}
      ></div>

      <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row">
          <div className="col-md-6">
              <h1 className="fw-bold display-4 mb-3">Contacto</h1>
              <p className="lead">
              Para consultas o solicitudes, contáctenos mediante los canales disponibles. Su mensaje será gestionado conforme a nuestros protocolos institucionales.
              </p>
              <a href="#detalle-servicios" className="btn btn-outline-light mt-4">
              Ver Contacto
              </a>
          </div>
          </div>
      </div>
      </motion.section>
      <motion.section
        id = 'Contactanos'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        style={{
          background: colors.accent,
          padding: '120px 0 80px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <motion.div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: colors.light,
            zIndex: 1
          }}
        />
        
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8 }}
                style={{
                  background: colors.light,
                  borderRadius: '20px',
                  padding: '3rem',
                  
                }}
              >
                <h3 
                  style={{ 
                    fontSize: '1.75rem', 
                    fontWeight: '600',
                    color: colors.dark
                  }}
                >
                  ¿Dónde estamos ubicados?
                </h3>
                <h3 
                  style={{ 
                    fontSize: '1.75rem', 
                    fontWeight: '400',
                    marginBottom: '2rem',
                    color: colors.dark
                  }}
                >
                  San Borja - Lima, Perú
                </h3>
                <div class="linea-naranja"></div>
                <h3 
                  style={{ 
                    fontSize: '1.75rem', 
                    fontWeight: '600',
                    color: colors.dark
                  }}
                >
                  Contáctanos
                </h3>
                <h3 
                  style={{ 
                    fontSize: '1.75rem', 
                    fontWeight: '400',
                    marginBottom: '2rem',
                    color: colors.dark
                  }}
                >
                  desarrollo@im-ra.com
                </h3>
              </motion.div>
            </div>
            <div className="col-lg-6">
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8 }}
                style={{
                  background: colors.light,
                  borderRadius: '20px',
                  padding: '3rem',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                }}
              >
                <p
                  style={{
                    color: colors.primary,
                  }}
                
                >Ponte en contacto</p>
                <h2 
                  style={{ 
                    fontSize: '1.75rem', 
                    fontWeight: '600',
                    marginBottom: '2rem',
                    color: colors.dark
                  }}
                >
                  Formulario de contacto
                </h2>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="nombre"
                          name="nombre"
                          placeholder="Tu nombre o empresa"
                          value={formData.nombre}
                          onChange={handleInputChange}
                          style={{
                            border: 'none',
                            borderRadius: '10px',
                            background: colors.gray,
                            padding: '1.5rem 1rem'
                          }}
                          required
                        />
                        <label htmlFor="nombre">Tu nombre</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Tu email"
                          value={formData.email}
                          onChange={handleInputChange}
                          style={{
                            border: 'none',
                            borderRadius: '10px',
                            background: colors.gray,
                            padding: '1.5rem 1rem'
                          }}
                          required
                        />
                        <label htmlFor="email">Tu email</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="asunto"
                          name="asunto"
                          placeholder="Asunto"
                          value={formData.asunto}
                          onChange={handleInputChange}
                          style={{
                            border: 'none',
                            borderRadius: '10px',
                            background: colors.gray,
                            padding: '1.5rem 1rem'
                          }}
                          required
                        />
                        <label htmlFor="asunto">Asunto</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          id="mensaje"
                          name="mensaje"
                          placeholder="Tu mensaje"
                          value={formData.mensaje}
                          onChange={handleInputChange}
                          style={{
                            border: 'none',
                            borderRadius: '10px',
                            background: colors.gray,
                            padding: '1.5rem 1rem',
                            height: '150px'
                          }}
                          required
                        ></textarea>
                        <label htmlFor="mensaje">Tu mensaje</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <motion.button
                        type="submit"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        style={{
                          width: '100%',
                          background: colors.primary,
                          color: colors.light,
                          border: 'none',
                          borderRadius: '10px',
                          padding: '1rem',
                          fontSize: '1.1rem',
                          fontWeight: '500',
                          cursor: 'pointer'
                        }}
                      >
                        {status.submitting ? 'Enviando...' : 'Enviar mensaje'}
                      </motion.button>
                      {status.info.msg && (
                        <div 
                          className={`mt-3 text-center ${status.info.error ? 'text-danger' : 'text-success'}`}
                          role="alert"
                        >
                          {status.info.msg}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.section>

      <motion.section className="pb-5">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              borderRadius: '20px',
              overflow: 'hidden',
              height: '400px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31209.86791957527!2d-77.01578788456813!3d-12.096161691231561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c7d19478c6bf%3A0xb53809bf8f8b06c8!2sSan%20Borja!5e0!3m2!1ses!2spe!4v1760045513893!5m2!1ses!2spe"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Ubicación"
            ></iframe>
          </motion.div>
        </div>
      </motion.section>
    </MainLayout>
  );
};

export default Contactanos;